// extracted by mini-css-extract-plugin
export default {"container":"ProductData_container__pnDv9","verticalContainer":"ProductData_verticalContainer__ljxML"};